// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }


  SITE.mobileFooter = function() {

    $(".nav-footer > ul > li").has('ul').append('<div class="footer-icon footer-icon--closed">');
    $(".footer-icon").click(function(e) {
      if(this.classList.contains('footer-icon--closed')) {
        this.classList.remove('footer-icon--closed');
        this.classList.add('footer-icon--opened');
        this.parentElement.children[1].classList.add('footer__sub-nav--expanded');
        this.parentElement.children[1].classList.remove('footer__sub-nav--closed');
        this.parentElement.children[1].style.display="block";


      }
      else if (this.classList.contains('footer-icon--opened')) {

        this.classList.add('footer-icon--closed');
        this.classList.remove('footer-icon--opened');
        this.parentElement.children[1].classList.add('footer__sub-nav--closed');
        this.parentElement.children[1].classList.remove('footer__sub-nav--expanded');
        this.parentElement.children[1].style.display="";
      }
      }
    )
  }

})();


// Invocations

$(function () {
  // Make SVG maps work in IE.
  svg4everybody();

SITE.mobileFooter();

});
